module.exports = "<div ng-if='vm.message' class=\"banner-message__wrapper\">\n  <span class=\"icon info_icon info-icon__wrapper\"></span>\n  <span>{{ vm.message }}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/common/bannerMessage/bannerMessage.html
// module id = 266
// module chunks = 1